import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityAuthenticationLogoutPostAsyncSlice } from './post';

export const securityAuthenticationLogoutReducers = combineReducers({
	post: securityAuthenticationLogoutPostAsyncSlice.asyncReducers
});

export const securityAuthenticationLogoutWatchers = combineAllWatchers([
	securityAuthenticationLogoutPostAsyncSlice.asyncWatchers
]);
